import { loyaltyActions } from './models/loyalty';
import { orderingActions } from './models/ordering';

export const actions = {
  loyalty: loyaltyActions,
  ordering: orderingActions,
};
